import {
  dimensionIconographyMd,
  dimensionIconographySm,
  dimensionIconographyXs,
  dimensionMenuWidthLg,
  dimensionMenuWidthXs,
  dimensionPanelWidth2xs,
  dimensionPanelWidthLg,
  dimensionPanelWidthMd,
  dimensionRadius025,
  dimensionSize200,
  dimensionSize300,
  dimensionSize400,
  dimensionSize600,
  dimensionSize800,
  dimensionSpace100,
  dimensionSpace050,
  dimensionSpace200,
  dimensionSpace300,
  dimensionSpace400,
  dimensionStrokeWidth012,
  dimensionStrokeWidth025,
  dimensionStrokeWidth037,
  typographyLineheightLg,
  typographyLineheightMd,
  typographyLineheightSm,
  typographyLineheightXl,
  typographyLineheightXs,
  effectAnimationDelayLong2,
  effectAnimationDelayMedium1,
  effectAnimationDelayMedium3,
  effectAnimationDelayInstant,
  effectAnimationDelayShort2,
  effectAnimationDurationMedium1,
  effectAnimationDurationShort3,
  effectMotionShort2,
  effectMotionShort3,
} from '@ds-mo/tokens/ts';

/** TokoMo CSS custom-property names for shared component defaults (runtime resolution). */
export const TOKEN_DEFAULTS = {
  space050: dimensionSpace050,
  space100: dimensionSpace100,
  space200: dimensionSpace200,
  space300: dimensionSpace300,
  space400: dimensionSpace400,
  radius025: dimensionRadius025,
  strokeWidth012: dimensionStrokeWidth012,
  strokeWidth025: dimensionStrokeWidth025,
  strokeWidth037: dimensionStrokeWidth037,
  size200: dimensionSize200,
  size300: dimensionSize300,
  size400: dimensionSize400,
  size600: dimensionSize600,
  size800: dimensionSize800,
  iconographyMd: dimensionIconographyMd,
  iconographySm: dimensionIconographySm,
  iconographyXs: dimensionIconographyXs,
  panelWidth2xs: dimensionPanelWidth2xs,
  panelWidthMd: dimensionPanelWidthMd,
  panelWidthLg: dimensionPanelWidthLg,
  menuWidthXs: dimensionMenuWidthXs,
  menuWidthLg: dimensionMenuWidthLg,
  lineheightLg: typographyLineheightLg,
  lineheightMd: typographyLineheightMd,
  lineheightSm: typographyLineheightSm,
  lineheightXl: typographyLineheightXl,
  lineheightXs: typographyLineheightXs,
  motionShort2: effectMotionShort2,
  motionShort3: effectMotionShort3,
  animationDurationShort3: effectAnimationDurationShort3,
  animationDurationMedium1: effectAnimationDurationMedium1,
  animationDelayInstant: effectAnimationDelayInstant,
  animationDelayMedium1: effectAnimationDelayMedium1,
  animationDelayMedium3: effectAnimationDelayMedium3,
  animationDelayShort2: effectAnimationDelayShort2,
  animationDelayLong2: effectAnimationDelayLong2,
  /** Unmeasured menu height fallback: 20× base (160px at default scale). */
  menuFallbackHeight: 'calc(var(--dimension-size-base) * 20)',
  /** Unmeasured tooltip width fallback: size-800 + size-200 (80px). */
  tooltipFallbackWidth: 'calc(var(--dimension-size-800) + var(--dimension-size-200))',
  /** Fill-mode donut diameter floor: 16× size-base (128px). */
  donutFillMin: 'calc(var(--dimension-size-base) * 16)',
  /** Fill-mode donut diameter ceiling: 24× size-base (192px). */
  donutFillMax: 'calc(var(--dimension-size-base) * 24)',
} as const;

export type TokenDefaultKey = keyof typeof TOKEN_DEFAULTS;

/** Valid CSS length strings for overlay offset props — bind on `sideOffset` / `alignOffset` in hosts. */
export const TOKEN_CSS_LENGTHS = {
  space050: `var(${dimensionSpace050})`,
  space200: `var(${dimensionSpace200})`,
  menuWidthXs: `var(${dimensionMenuWidthXs})`,
  menuWidthLg: `var(${dimensionMenuWidthLg})`,
} as const;
